'use strict';

/**
 * Service: Shared Functions
 *
 * @version
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdSharedFunctionsService for ES6 usage
 * 9.0.1 #704 MLIBJS-78 Multiple side menu items are being highlighted
 * 8.14.6 #656 MLIBJS-32 Update isActive Function
 * 8.3.0 #587 Add missing directives, Improve `filterSearch`
 * 5.9.1 #404 Order date formatting doesn't work on iPads
 * 5.8.0 #393 Add getDescendantProperty to Main Library
 * 5.8.0 #391 Add 'removeArrayElement' to wdSharedFunctionsService
 * 5.7.0 #380 Add Filter Search as main library shared function
 * 5.6.1 #343 Minor Style for Tracker UI Refactor #343
 * 5.4.0 #326 Build failing due to 'let'
 * 5.4.0 #320 Changes based on Ordering UI tracker integration
 * 5.4.0 #322 Add guid() to wdSharedFunctionsService
 * 5.4.0 #319 Add Array Sort Function
 * 5.0.1 #286 Standardise Data Loading and Parsing Services
 * 5.0.1 #278 Re-factor for Dashboard
 * 3.2.0 #261 Unit Test Coverage, Tidy
 * 3.1.1 #255 Add More Shared Functions
 * 3.0.0 #236 Add Shared Functionality to Main Library
 * 1.9.0 #212 Extend wdSharedFunctions to Include parseDatePickerFormat
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2015-2020 Build Centrix
 */
var wdSharedFunctionsService = angular.module('wd.shared', ['angularMoment', 'ngRoute'])
    .factory(
    'wdSharedFunctionsService',
    [
        '$window', '$location', 'moment', '$route', 'wdStorageService',
        function ($window, $location, moment, $route, wdStorageService)
        {

            var service = {};

            /**
             * Convert float time in hours to HH:MM format
             *
             * @since 5.0.1
             *
             * @param time passed as hours, e.g. 5.133
             * @param full - Return full human readable string, e.g. 5 hours 33 minutes
             * @returns {string}
             **/
            service.convertFloatHoursToHoursAndMinutes = function(time, full) {

                var newTime = '0:00';

                if (time > 0) {
                    var hours = Math.floor(time);
                    var minutes = Math.round((time - hours) * 60);

                    var hoursString = ' hours ';
                    var minutesString = ' minutes';

                    if (hours === 1) {
                        hoursString = ' hour ';
                    }
                    if (minutes === 1) {
                        minutesString = ' minute';
                    }

                    if (minutes < 10) { // read "2:06" instead of "2:6"
                        if (!full) {
                            minutes = '0' + minutes;
                        }
                    }

                    if (full) {
                        if (hours < 1) {
                            newTime = minutes + minutesString;
                        }
                        else {
                            newTime = hours + hoursString + minutes + minutesString;
                        }
                    }
                    else {
                        newTime = hours + ':' + minutes;
                    }
                }

                return newTime;
            };

            /**
            * Convert Seconds to a Human Readable Format
            *
            * @since 1.6.0
            * @param {Integer} seconds
            */
            service.convertIntervalForDisplay = function (seconds)
            {

                /* istanbul ignore else */
                if (seconds) {

                    if (seconds >= 3600) {
                        return moment().startOf('day').seconds(seconds).format('H:mm:ss');
                    } else {
                        return moment().startOf('day').seconds(seconds).format('mm:ss');
                    }

                }

            };

            /**
             * Convert a string to a float
             *
             * @since 5.0.1
             *
             * @param value
             * @returns {Number}
             */
            service.convertStringToFloat =  function(value) {

                var result = parseFloat(value);

                if (isNaN(result)) {
                    result = 0.00;
                }

                return result;
            };

            /**
             * Convert a string to Title Case
             *
             * @since 1.6.0
             * @param {String} value
             * @returns {String}
             */
            service.convertStringToTitleCase = function(value)
            {

                return value.replace(
                    /\w\S*/g, function (txt)
                    {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );

            };

            /**
             * Builds a GUID
             *
             * @returns {string}
             */
            service.createGUID = function() {

                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();

            };

            /**
             * Filter Object Array by Search Value
             * Note: If no searchable keys are included, will search the entire object array. 
             * 
             * @since 8.3.0
             * 
             * @param {String} searchValue
             * @param {Array} searchList
             * @param {Array} searchableKeys
             * @returns {Array}
             */
            service.filterSearch = function(searchValue, searchList, searchableKeys)
            {
                var results = [];

                // Set search value to lower case
                searchValue = searchValue ? service.trimString(searchValue).toLowerCase() : '';

                // If there is a search value...
                if(searchValue !== '') {

                    // Loop through each row...
                    for (var i = 0; i < searchList.length; i++) {

                        // For each key in the row...
                        for (var key in searchList[i]) {
                            if (searchList[i].hasOwnProperty(key)) {

                                var target = null;

                                // If we have searchable keys, check those, otherwise, check everything...
                                if (searchableKeys) {

                                    target = searchList[i][key] && searchableKeys.indexOf(key) > -1 ? searchList[i][key].toString() : null;

                                } else {

                                    target = searchList[i][key] ? searchList[i][key].toString() : null;

                                }

                                // Filter results by target
                                if(target) {

                                    if (service.trimString(target).toLowerCase().indexOf(searchValue) > -1) {

                                        results.push(searchList[i]);
                                        break;

                                    }

                                }

                            }

                        }

                    }

                } else { results = searchList; }

                return results;

            };

            /**
             * Get a single object from an Array based on the value, targe key and datasource
             *
             * @since 3.1.1
             * @param value
             * @param key
             * @param datasource
             * @returns {{}}
             */
            service.getArrayObjectByKey = function(value, key, datasource)
            {

                var result = {};

                for(var i = 0; i<datasource.length; i++){

                    /* istanbul ignore else */
                    if(datasource[i][key] === value){
                        result = datasource[i];
                    }

                }

                return result;

            };

            /**
             * Get Possible Descendant Property of an Object
             *
             * @since 5.8.0
             * @param dataObject
             * @param propertyPath
             * @returns {*}
             */
            service.getDescendantProperty = function(dataObject, propertyPath) {

                var dataObjectArray = propertyPath.split('.');
                while(dataObjectArray.length && dataObject) { dataObject = dataObject[dataObjectArray.shift()]; }
                return dataObject;

            };

            /**
             * Get an array of items based on a key and value
             *
             * @since 3.1.1
             * @param value
             * @param key
             * @param datasource
             * @returns {Array}
             */
            service.getMultipleArrayObjectsByKey = function(value, key, datasource)
            {

                var results = [];

                for(var i = 0; i<datasource.length; i++){

                    /* istanbul ignore else */
                    if(datasource[i][key] === value){

                        results.push(datasource[i]);

                    }

                }

                return results;

            };

            /**
             * Get Query String
             *
             * @since 1.6.0
             * @returns {Object}
             */
            service.getQueryString = function() {

                return $location.search();

            };

            /**
             * Get Total based on Items in Array
             *
             * @since 3.0.0
             * @param items
             * @param key
             * @returns {number}
             */
            service.getTotal = function (items, key)
            {

                var result = 0;

                for (var i = 0; i < items.length; i++) {

                    result += items[i][key];

                }

                return result;

            };

            /**
             * Get Unique Values from an Array by Key
             *
             * @since 3.0.0
             * @param collection
             * @param property
             * @returns {Array}
             */
            service.getUniqueValues = function (collection, property)
            {

                var results = [];

                for (var i = 0; i < collection.length; i++) {

                    var groupingKey = collection[i][property];
                    var index = results.indexOf(groupingKey);

                    /* istanbul ignore else */
                    if (index === -1) {
                        results.push(groupingKey);
                    }

                }

                return results;
            };

            /**
             * Used in order to not break unit tests
             *
             * @since 1.6.0
             * @param {string} destination Destination URL to redirect to
             * @param {number} delay Delay before redirecting (optional)
             */
            /* istanbul ignore next */
            service.goToLocation = function(destination, delay) {

                if (typeof delay === 'undefined') {

                    delay = 0; // default (in milliseconds)

                }

                setTimeout(function() {

                    $window.location.href = destination;

                }, delay);

            };

            /**
             * Set the Active Link
             *
             * @since 3.0.0
             * @param viewLocation
             * @returns {boolean}
             */
            service.isActive = function (viewLocation)
            {

                var result = false;

                if (viewLocation === $location.path()) {
                    result =  true;
                }

                return result;

            };

            /**
             * Check for an Empty Object
             *
             * @source http://stackoverflow.com/questions/4994201/is-object-empty
             * @since 3.0.0
             * @param obj
             * @returns {boolean}
             */
            service.isEmptyObject = function(obj) {

                // null and undefined are "empty"
                if (obj === null) { return true; }

                // Assume if it has a length property with a non-zero value
                // that that property is correct.
                if (obj.length > 0) { return false; }
                if (obj.length === 0) { return true; }

                // Otherwise, does it have any properties of its own?
                // Note that this doesn't handle
                // toString and valueOf enumeration bugs in IE < 9
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) { return false; }
                }

                return true;
            };

            /**
             * Is value in an array?
             *
             * @since 5.0.1
             */
            service.isInArray = function(value, array) {
                return array.indexOf(value) > -1;
            };

            /**
             * Set the browser window title
             *
             * @since 1.6.0
             * @param title
             */
            service.setWindowTitle = function(title) {

                $window.document.title = title;

            };

            /**
             * Parse date picker format
             *
             * The bootstrap datepicker uses a different format than the environment constants offers. Thus we are
             * reformatting the existing constant to the required format.
             *
             * @see https://angular-ui.github.io/bootstrap/#/datepicker
             *
             * @since 1.9.0 #212 Extend wdSharedFunctions to Include parseDatePickerFormat
             *
             * @param {string} systemDateFormat
             * @returns {string}
             */
            service.parseDatePickerFormat = function(systemDateFormat)
            {

                var result = systemDateFormat;

                result = result.replace(/D/g, 'd');
                result = result.replace(/Y/g, 'y');

                return result;

            };

            /**
             * Parse Dates in a Standard way for the UI
             *
             * NOTE: The replace, is due to an iPad bug. See issue: #404
             * @param stringDate
             * @returns {*}
             */
            service.parseStringToDate = function(stringDate) {

                var result;

                result = stringDate ? new Date(stringDate.replace(/-/g, '/')) : null;

                return result;

            };

            /**
             * Redirect to URL
             *
             * @since 1.6.0
             * @param {string} destinationUrl
             * @param {Boolean} [inNewWindow=false]
             * @param {number} delay
             */
            service.redirectToUrl = function(destinationUrl, inNewWindow, delay)
            {

                // Allows inNewWindow to be an optional arguement
                //if (typeof inNewWindow === 'undefined') { inNewWindow = false; }

                // Open in New Window if requested, otherwise open in current window
                if (inNewWindow === true) {

                    $window.open(destinationUrl, '_blank');

                } else {

                    service.goToLocation(destinationUrl, delay);

                }

                return true;

            };

            /**
             * Reload the Page
             *
             * @since 1.6.0
             */
            service.reloadPage = function ()
            {

                var result = true;

                $route.reload();

                return result;

            };

            /**
             * Remove duplicate values from an Array
             *
             * @since 5.0.1
             *
             * @params {Array} array
             * @returns {Array} unique
             */
            service.removeArrayDuplicates = function(array){
                var unique = [];

                for (var i = 0; i < array.length; i++) {
                    var current = array[i];

                    if (unique.indexOf(current) < 0) {
                        unique.push(current);
                    }
                }

                return unique;
            };

            /**
             * Remove Array Element
             *
             * @since 5.8.0
             * @param element
             * @param targetArray
             */
            service.removeArrayElement = function(element, targetArray) {

                var results = targetArray;

                for(var i = 0; i< results.length; i++) {

                    if(results[i] === element) {

                        results.splice(i, 1);

                    }

                }

                return results;

            };

            /**
             * Replace all instances of a character in a string
             *
             * @since 5.6.1
             * @param str
             * @param find
             * @param replace
             * @returns {*}
             */
            service.replaceAll = function(str, find, replace) {

                return str.replace(new RegExp(find, 'g'), replace);

            };

            /**
             * Set the browser window title
             *
             * @since 1.6.0
             * @param title
             */
            service.setWindowTitle = function(title)
            {

                $window.document.title = title;

            };

            /**
             * Set Default Sort Order on Object Array
             *
             * @since 5.4.0
             * @param array
             * @param key
             * @param reverse
             * @returns {Array}
             */
            service.sortArrayByKey = function(array, key, reverse){

                var results = [];

                if(!reverse) { results = array.sort(function(a,b) {return (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);} ); }
                else { results = array.sort(function(a,b) {return (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0);} ); }

                return results;

            };

            /**
             * Toggle the Sidebar on and Off
             *
             * @since 5.0.1
             */
            service.toggleSidebar = function (settings)
            {

                settings.sidebar.expanded = !settings.sidebar.expanded;
                wdStorageService.saveLocalStorageConfiguration('settings', settings);

            };

            /**
             * Trim String
             *
             * @since 5.7.0
             * @param s
             * @returns {string}
             */
            service.trimString = function(s)
            {
                var l = 0, r = s.length - 1;
                while (l < s.length && s[l] === ' ') {
                    l++;
                }
                while (r > l && s[r] === ' ') {
                    r -= 1;
                }
                return s.substring(l, r + 1);
            };

            return service;
        }
    ]
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdSharedFunctionsService;
}
// EOF
